import React, { ButtonHTMLAttributes, FC } from 'react';
import styled from '@xstyled/styled-components';
import BurgerIcon from '~/assets/icons/burger.svg';
import { t } from 'ttag';

type BurgerButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  'data-test-id'?: string | undefined;
};

const Button = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 50px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  overflow: visible;
  background: ${p => p.theme.colors.accentDark};
  position: relative;
  padding-bottom: 13px;
  &:hover {
    transform: scale(1.5);
  }
  &:focus {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 25px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid var(--color-focus-ring-inner);
    pointer-events: none;
  }
  @media ((max-width: 580px) and (max-height: 300px)) {
    padding-bottom: 4.5px;
    width: 25px;
    height: 25px;
  }
`;

const Burger = styled(BurgerIcon)`
  width: 16px;
  height: 16px;
`;

export const BurgerButton: FC<BurgerButtonProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  'data-test-id': dataTestId,
  'aria-label': ariaLabel,
  ...props
}) => (
  <Button
    {...props}
    aria-label={ariaLabel ?? t`Open course navigation`}
    data-test-id={`${dataTestId || 'burger-button'}`}
  >
    <Burger aria-hidden="true" focusable="false" />
  </Button>
);
